import { FC, memo, useMemo } from 'react';
// Import Types
import type { RecurrenceListProps } from './types';
import type { DynamicRowType } from '../DynamicRowList/types';
// Import Components
import DynamicRowList from 'components/common/DynamicRowList';
// Import Services
import { Helpers } from 'services';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Constants
import { RecurrenceDataColumnsConfig } from 'constants/common';

const { formatRecurrenceDates } = Helpers;

const RecurrenceList: FC<RecurrenceListProps> = ({ upcomingExecutions = [] }) => {
    const { partnerDateTimeWithoutSecondsFormat } = usePartnerDateFormats();

    const recurrenceRowsData = useMemo<DynamicRowType[]>(
        () => formatRecurrenceDates(upcomingExecutions, partnerDateTimeWithoutSecondsFormat),
        [partnerDateTimeWithoutSecondsFormat, upcomingExecutions],
    );

    return <DynamicRowList columnsConfig={RecurrenceDataColumnsConfig} rows={recurrenceRowsData} />;
};

export default memo(RecurrenceList);
